import { z } from "zod";

export const ControleServicosSchema = z.object({
  idServicosControlados: z.number().optional(),
  nroServico: z.string().optional(),
  descricao: z.string().optional(),
  ativo: z.boolean().optional().default(true),
  nomeArquivo: z.string().optional().nullable(),
  arquivo: z.instanceof(File).optional().nullable(),
});

export type ControleServicosForm = z.infer<typeof ControleServicosSchema>;
